export const $ = (query, context = document) => {
  const ctx = context instanceof Node
    ? context
    : (
      document.querySelector(context)
      || document
    );

  const nodeList = typeof query === 'string'
    ? ctx.querySelectorAll(query)
    : query;

  return nodeList instanceof NodeList
    ? Array.prototype.slice.call(nodeList)
    : [nodeList];
};

const show = (query) => $(query).map((element) => {
  element.removeAttribute('hidden');
  return element;
});

const hide = (query) => $(query).map((element) => {
  element.setAttribute('hidden', true);
  return element;
});

const toggle = (query, display) => $(query).map((element) => {
  const visible = display != null
    ? !!display
    : element.hasAttribute('hidden');
  const action = visible ? show : hide;

  action(element);

  return element;
});

const render = (node, {
  style, events, children, attrs, ...props
} = {}) => {
  const element = (
    typeof node === 'string'
      ? document.createElement(node)
      : node
  );

  if (!(element instanceof Node)) {
    // eslint-disable-next-line no-console
    console.warn('Elemento inválido.', element);
    return null;
  }

  if (props) {
    Object.entries(props).forEach(([key, val]) => {
      element[key] = val;
    });
  }

  if (attrs) {
    Object.entries(attrs).forEach(([key, val]) => {
      element.setAttribute(key, val);
    });
  }

  if (style) {
    Object.entries(style).forEach(([key, val]) => {
      element.style[key] = val;
    });
  }

  if (children instanceof Array) {
    children.forEach((kid) => {
      if (kid instanceof Node) {
        element.appendChild(kid);
      }
    });
  }

  if (events) {
    Object.entries(events).forEach(([name, fn]) => {
      if (typeof name === 'string' && fn instanceof Function) {
        element.addEventListener(name, fn);
      }
    });
  }

  return element;
};

$.show = show;
$.hide = hide;
$.toggle = toggle;
$.render = render;

export const isInViewport = (elem) => {
  const {
    top, left, bottom, right,
  } = elem.getBoundingClientRect();
  return (
    top >= 0 && left >= 0
    && bottom <= (window.innerHeight || document.documentElement.clientHeight)
    && right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const trigger = (el, name, detail) => {
  const customEvent = window.CustomEvent && typeof window.CustomEvent === 'function';
  const event = (
    customEvent
      ? new CustomEvent(name, { detail })
      : document.createEvent('CustomEvent')
  );

  event.initCustomEvent(name, true, true, detail);

  el.dispatchEvent(event);
};

document.querySelectorAll("[data-reticencias]").forEach((elemento) => {
  const limite = elemento.dataset.reticencias;
  const acimaLimite = elemento.innerText.length > limite;
  const pontoOuVazio = acimaLimite ? '...' : '';
  elemento.innerText = elemento.innerText.substring(0, limite) + pontoOuVazio.trim();
})

document.querySelectorAll("[data-reticencias-paragrafo").forEach((elemento) => {
  const limite = elemento.dataset.reticenciasParagrafo;
  let acimaLimite = false;

  if (elemento.innerText.indexOf(".") < limite && elemento.innerText.indexOf(".") > 0){
    elemento.innerText = elemento.innerText.substring(0, elemento.innerText.indexOf(".")).trim() + '.';
    return
  }

  acimaLimite = elemento.innerText.length > limite;
  const pontoOuVazio = acimaLimite ? '...' : '';
  elemento.innerText = elemento.innerText.substring(0, limite).trim() + pontoOuVazio.trim();
})

document.querySelectorAll("[data-reticencias-timeout]").forEach((elemento) => {
  const limite = elemento.dataset.reticenciasTimeout.split(", ")[0];
  const tempo = elemento.dataset.reticenciasTimeout.split(", ")[1];
  const acimaLimite = elemento.innerText.length > limite;
  const pontoOuVazio = acimaLimite ? '...' : '';
  
  setTimeout(() => {
    elemento.innerText = elemento.innerText.substring(0, limite) + pontoOuVazio.trim();
  }, tempo);
})

document.querySelectorAll(".caixa-baixa-titulo").forEach((elemento) => {
  const tamanho = elemento.innerText.length;

  elemento.innerText = `${elemento.innerText.substring(0, 1).toUpperCase()}${elemento.innerText.substring(1, tamanho).toLowerCase()}`;
})

window.onload = () => {
  var ambiente = window.location.origin.includes('webnetserver.com.br') ? true : false;
  var cidade = document.head.querySelector("meta[property='og:url']").content.split("//")[1].split("/")[1];
  
  if (ambiente){
    document.querySelectorAll("a").forEach(item => {
      if(item.href.includes("webnetserver.com.br") && !item.href.split("//")[1].split("/")[1].includes(cidade)){
        item.href = `${item.href.split("webnetserver.com.br")[0]}webnetserver.com.br/${cidade}${item.href.split("webnetserver.com.br")[1]}`;
      }
    })
  }
}



document.querySelectorAll("adicionar-nome-classe").forEach((elemento) => {
  const div = elemento;
  const lista = div.querySelector("ul");
  var id = -1;
  let scroll = 0;

  function MousePressionado(event) {
    if(id == -1) { 
      id = setInterval(EnquantoMousePressionado, 1);
    }
  }
    
  function MouseSolto(event) {
    if(id != -1) {
      clearInterval(id);
      id = -1;
    }
  }

  function EnquantoMousePressionado() {
    lista.scrollBy(scroll, 0);
  }

  div.querySelectorAll("button").forEach(item => {
    item.addEventListener("mousedown", function(){ 
      scroll = item.classList[0].includes("prev") ? -2 : 2;
      MousePressionado();
    });
    item.addEventListener("touchstart", function(){ 
      scroll = item.classList[0].includes("prev") ? -2 : 2;
      MousePressionado();
    });
    item.addEventListener("mouseup", MouseSolto);
    item.addEventListener("touchend", MouseSolto);
    item.addEventListener("mouseout", MouseSolto);
  })
})

var home = document.querySelector("meta[name='home'][content='true']") !== null ? true : false;
if (home){
  document.body.classList.add("home");
}